import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simulador-vuelo',
  templateUrl: './simulador-vuelo.component.html',
  styleUrls: ['./simulador-vuelo.component.scss']
})
export class SimuladorVueloComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
